var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"elfsight-app-dfc6d54b-9164-4556-a152-ebdfcba892df",attrs:{"data-elfsight-app-lazy":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }